// Fonction utilitaire pour ajouter un timeout à n'importe quelle promesse
export function withTimeout<T>(promise: Promise<T>, timeoutMs: number): Promise<T | undefined> {
  const timeoutPromise = new Promise<undefined>(resolve => {
    setTimeout(() => resolve(undefined), timeoutMs);
  });

  return Promise.race([promise, timeoutPromise]);
}
